import { render } from "./PanelVendedor.vue?vue&type=template&id=c4560986"
import script from "./PanelVendedor.vue?vue&type=script&lang=js"
export * from "./PanelVendedor.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__